#import "../../../../../../../../common/graphql/EntityDocumentsFields.graphql"
mutation AttachBatchTransactionDocument(
  $input: AttachBatchTransactionDocumentInput!
) {
  attachBatchTransactionDocument(input: $input) {
    entityDocuments {
      ...EntityDocumentsFields
    }
  }
}
